export const Flag = () => {
    return (
        <svg fill="currentColor" aria-hidden="true" viewBox="0 0 60 65">
            <path d="M6.046 47.672h49.382c3.005 0 4.68-3.471 2.81-5.823L47.042 27.775a3.589 3.589 0 0 1 0-4.468L58.237 9.233c1.87-2.352.196-5.823-2.809-5.823H6.047z" />
            <path
                d="M6.046 62.027a2.692 2.692 0 0 1-5.38.127l-.003-.127V3.41a2.692 2.692 0 0 1 5.38-.126l.003.126z"
                opacity=".5"
            />
        </svg>
    );
};
